import styled from "styled-components";


export const Container = styled.div`
  position: fixed;
  width: 100vw;
  z-index: 999; /* Ensure it's above other elements */
  .active {
    border-bottom: 4px solid var(--white);
    img {
      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)
        brightness(103%) contrast(103%);
    }
  }
`;
export const SidebarContainer = styled.div`
  background-color: var(--black);
  width: 70px;
  height: 3.5rem;
  border-radius: 0 0 30px 30px;
  padding: 0 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top: 0; /* Position at the top */
  right: 0; /* Align to the left */
  z-index: 1000; /* Ensure it's above other elements */
  @media (max-width: 550px) {
    /* Media query for small screens */
    width: 18%; /* Reduce width to 75% */
  }
`;

export const Item = styled.a`
  text-decoration: none;
  color: var(--white);
  height: 100%;
  padding: 0 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: "24px";
  border-bottom: ${(props) =>
    props.isActive ? "4px solid var(--white)" : "none"};
  &:hover {
    border-bottom: 4px solid var(--white);
  }
  @media (max-width: 500px) {
    font-size: 0.8rem; /* Reduce font size on smaller screens */

  }
  @media (max-width: 450px) {
    font-size: 0.8rem; /* Reduce font size on smaller screens */

  }
  @media (max-width: 400px) {
    font-size: 0.8rem; /* Reduce font size on smaller screens */
    padding: 0 -1%;
  }
  @media (max-width: 330px) {
    font-size: 0.8rem; /* Reduce font size on smaller screens */
 
  }
`;

export const SelectAll = styled.button`
  background-color: var(--black);
  border: none;
  width: ${(props) =>
    props.clicked ? "7rem" : "7rem"}; /* Increase width when clicked */
  height: 2.5rem; /* Keep height the same */
  border-radius: 50px; /* Make it oval */
  margin: 0.5rem 0 0 0.5rem;
  top: 0; /* Position at the top */
  right: ${(props) => (props.clicked ? "80px" : "80px")};
  cursor: pointer;
  z-index: 1500;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  transition: width 0.3s ease; /* Smooth transition for width change */
  color: var(--white); /* Set text color */
  font-weight: bold;
  &::before,
  &::after {
    display: ${(props) =>
      props.clicked ? "none" : "none"}; /* Hide lines when clicked */
    content: "";
    background-color: var(--white);
    height: 2px;
    width: 1rem;
    position: absolute;
    transition: all 0.3s ease;
  }

  &::before {
    top: 1rem; /* Position for the first line */
    transform: rotate(0); /* No rotation */
  }

  &::after {
    top: 1.5rem; /* Position for the second line */
    transform: rotate(0); /* No rotation */
  }
  @media (max-width: 550px) {
    right: ${(props) => (props.clicked ? "22%" : "22%")};
    width: ${(props) =>
      props.clicked ? "6rem" : "6rem"}; /* Increase width when clicked */
  }
  @media (max-width: 450px) {
    right: ${(props) => (props.clicked ? "22%" : "22%")};
    width: ${(props) =>
      props.clicked ? "5.5rem" : "5.5rem"}; /* Increase width when clicked */
  }
  @media (max-width: 400px) {
    right: ${(props) => (props.clicked ? "20%" : "20%")};
    width: ${(props) =>
      props.clicked ? "5.5rem" : "5.5rem"}; /* Increase width when clicked */
  }

  @media (max-width: 360px) {
    right: ${(props) => (props.clicked ? "20%" : "20%")};
    width: ${(props) =>
      props.clicked ? "5rem" : "5rem"}; /* Increase width when clicked */
  }
`;
export const Button = styled.button`
  background-color: var(--black);
  border: none;
  width: ${(props) =>
    props.clicked ? "5rem" : "2.5rem"}; /* Increase width when clicked */
  height: 2.5rem; /* Keep height the same */
  border-radius: 50px; /* Make it oval */
  margin: 0.5rem 0 0 0.5rem;
  top: 0; /* Position at the top */
  right: ${(props) =>
    props.clicked ? "200px" : "20px"}; /* Dynamically set based on clicked */
  cursor: pointer;
  z-index: 1500;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  transition: width 0.3s ease; /* Smooth transition for width change */
  color: var(--white); /* Set text color */
  font-weight: bold;
  &::before,
  &::after {
    display: ${(props) =>
      props.clicked ? "none" : "block"}; /* Hide lines when clicked */
    content: "";
    background-color: var(--white);
    height: 2px;
    width: 1rem;
    position: absolute;
    transition: all 0.3s ease;
  }

  &::before {
    top: 1rem; /* Position for the first line */
    transform: rotate(0); /* No rotation */
  }

  &::after {
    top: 1.5rem; /* Position for the second line */
    transform: rotate(0); /* No rotation */
  }
  @media (max-width: 550px) {
    right: ${(props) =>
      props.clicked ? "45%" : "20px"}; /* Dynamically set based on clicked */
  }
`;